<template>
    <div>
        <a class="dropdown-item language-container" @click.prevent="showModal">
            {{ trans('navbar')['Email Notifications'] }}
        </a>
        <div class="modal" @keydown.esc="closeModal" id="emailNotificationsModal" tabindex="-1" role="dialog"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" style="z-index: +100">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ trans('navbar')['Email Notifications'] }}</h5>
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <h5>{{ trans('forms').notification_preferences.email_templates.please_select }}</h5>
                                <div class="form-check" v-for="(option,optionName) in notificationOptions">
                                    <input class="form-check-input"
                                           type="checkbox"
                                           :id="'notif-'+optionName"
                                           v-model="notificationOptions[optionName]">
                                    <label class="form-check-label"
                                           :for="'notif-'+optionName">
                                        {{
                                            trans('forms').notification_preferences.email_templates.template_names[optionName]
                                        }}
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            {{ trans('forms').notification_preferences.email_templates.close }}
                        </button>
                        <button type="button" @click="savePreferences" class="btn btn-primary">
                            {{ trans('forms').notification_preferences.email_templates.save }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "EmailNotificationModal",
    components: {},
    data() {
        return {
            notificationOptions: {},
        }
    },
    mounted() {
        $('div.modal').appendTo('#endofbody');
    },
    methods: {
        showModal: function () {
            axios.get(route('user.email-notifications-options'))
                .then((result) => {
                    this.notificationOptions = result.data;
                    $('#emailNotificationsModal').modal({backdrop: 'static'}).modal('show')
                });
        },
        closeModal: function () {
            $('#emailNotificationsModal').modal('hide');
        },
        savePreferences: function () {
            axios.post(route('user.email-notifications-options.store'),
                {
                    notification_preferences: this.notificationOptions
                })
                .then((result) => {
                    this.notificationOptions = result.data;
                    $('#emailNotificationsModal').modal('hide');
                });
        }
    }
}
</script>

<style>

</style>
